import { z } from "zod";
export const SPONSORED_OPENING_WINDOWS = 3;
export const SPONSORED_FIXED_WINDOWS = 0;
export { WINDOW_VARIANTS, WINDOW_TOTAL_CENTS, formatWindowPrice, windowSponsorshipInterest, windowSponsorshipPrice, WINDOW_ADVERTISING_YEARS, WINDOW_ADVERTISING_LAYOUT } from "../../supabase/functions/_shared/window-sponsorship";
export type { WindowVariantId, WindowShare } from "../../supabase/functions/_shared/window-sponsorship";

export const windowSponsorshipSchema = z.object({
  window_share: z.enum(["ganz", "halb"]).default("ganz"),
  window_variant: z.enum(["oeffnend", "festverglast"], { errorMap: () => ({ message: "Bitte wähle eine Fenstervariante." }) }),
  firma: z.string().trim().max(200),
  ansprechpartner: z.string().trim().min(1, "Bitte gib deinen Namen an.").max(100),
  email: z.string().trim().email("Bitte gib eine gültige E-Mail-Adresse an.").max(255),
  telefon: z.string().trim().max(30).refine(v => !v || (/^[\d\s+\-()]+$/.test(v) && v.replace(/\D/g, "").length >= 5), "Bitte prüfe deine Telefonnummer."),
  nachricht: z.string().trim().max(5000),
  datenschutz: z.literal(true, { errorMap: () => ({ message: "Bitte bestätige die Datenschutzerklärung." }) }),
});